import qs from 'qs';

export interface IAIPaintConfig {
  pictureType: string;
  activeTab: string;
  searchText: string
  auto: boolean;
}

const tabHash:{[props: string]: string} = {
  '关键词': 'key',
  '提示词': 'tips'
}

export const AIPaintUrl = 'https://art.forchange.cn/';

export function getAIPaintIframeUrl(config?: IAIPaintConfig) {
  let query = '';

  const tabType=  config?.activeTab || ''

  const queryData = qs.stringify({
    'search-text': config?.searchText,
    'active-tab': tabHash[tabType],
    'picture-type': config?.pictureType,
    auto: config?.auto,
  });

  if (queryData) {
    query = '?' + queryData;
  }

  return AIPaintUrl + query;
}
